<template>
    <template v-if="gradePill">
        <BadgePill color="gray" v-if="gradePill.absent" :size="size">
            {{ $t('messages.absent') }}
        </BadgePill>
        <Tippy v-else>
            <BadgePill :color="gradePill.color" :size="size">
                {{ gradePill.letter }}
            </BadgePill>
            <template #content>
                {{ gradePill.text }}
            </template>
        </Tippy>
    </template>
</template>
<script>
import BadgePill from '@/components/BadgePill.vue';
import { Tippy } from 'vue-tippy';

export default {
    name: 'GradePill',
    components: {
        BadgePill,
        Tippy,
    },
    props: {
        gradePill: {
            type: Object,
            default: null,
            required: false,
        },
        size: {
            type: String,
            default: 'default',
        },
    },
};
</script>
